import ComparisonItem from '@/types/comparison-item';
import { ApiAction, Action, Result, AsyncResult } from '..';
import api from '../redux-api';

// Types
import { SuitabilityAnalysisState } from './types/suitability-analysis';
import SuitabilityAnalysisPortfolio from '@/types/suitability-analysis-portfolio';

const INITIAL_STATE: SuitabilityAnalysisState = null;

// Actions
export const GET_SUITABILITY_ANALYSIS: ApiAction = {
  type: 'connect/suitability-analysis/get',
  endpoint: 'comparisons/suitability',
};

const CLEAR_SUITABILITY_ANALYSIS: Action = {
  type: 'connect/suitability-analysis/clear',
};

// Reducer
export default function reducer(state: SuitabilityAnalysisState = INITIAL_STATE, action: Action): SuitabilityAnalysisState {
  switch (action.type) {
    case `${GET_SUITABILITY_ANALYSIS.type}_SUCCESS`: {
      return action.data.results;
    }
    case `${GET_SUITABILITY_ANALYSIS.type}_ERROR`: {
      // In case of API error, set state as an empty array
      // This allows connected components to differentiate between a comparison that
      // never ran suitability analysis and a comparison that ran it but encountered an error
      return [];
    }
    case CLEAR_SUITABILITY_ANALYSIS.type: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}

// Action creators
export const getSuitabilityAnalysis =
  (comparisonItems: ComparisonItem[], contactId?: string): AsyncResult<SuitabilityAnalysisPortfolio[]> =>
  () => {
    const params = {
      ...(contactId && { contactId }),
    };

    return api.post(GET_SUITABILITY_ANALYSIS, params, { comparisonItems });
  };

export const clearSuitabilityAnalysis = (): Result<void> => dispatch => dispatch(CLEAR_SUITABILITY_ANALYSIS);
